<template>

    <div v-if="!opportunitiesNearMeResponse.results">
        Loading opportunities...
    </div>
    <div v-else>
        <slot name="heading" :location="location">
            <p class="mb-5 text-xl font-medium opp-header">Opportunities near <br><em>{{ location }}</em></p>
        </slot>
        <div class="pb-5 gap-x-4 md:gap-x-5 md:gap-y-1 gap-y-3 opp-container ">
            <div class="opp-near-card "
                 v-for="opportunity in opportunities"
                 :key="opportunity.id">
                <slot name="opportunity" v-bind="opportunity">
                    <OpportunityCardMinimal v-if="use === 'minimal'" :opportunity="opportunity"></OpportunityCardMinimal>
                    <OpportunityCardStacked v-else-if="use === 'stacked'" :opportunity="opportunity"></OpportunityCardStacked>
                    <OpportunityCard v-else :opportunity="opportunity"></OpportunityCard>
                </slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetOpportunitiesNearMeRequest, GetOpportunitiesNearMeResponse,
} from "@/dtos";

import OpportunityCard from "./OpportunityCard.vue";
import OpportunityCardMinimal from "./OpportunityCardMinimal.vue";
import OpportunityCardStacked from "./OpportunityCardStacked.vue";

const props = defineProps({
    numOfPosts: {
        type: Number,
        default: 6
    },
    use: {
        type: String,
        default: "card"
    },
})

const use = ref(props.use);
const opportunitiesNearMeResponse: Ref<GetOpportunitiesNearMeResponse> = ref({});
const location = ref('');
const ip = ref("");

const opportunities = computed( () => {
    return opportunitiesNearMeResponse.value.results;
});

onMounted(async () => {
    let urlParams = new URLSearchParams(window.location.search);
    ip.value = urlParams.get("ip") ?? "";
    await getOpportunitiesNearMeForWidget();
});

const getOpportunitiesNearMeForWidget = async () => {
    await client.get<GetOpportunitiesNearMeResponse>(new GetOpportunitiesNearMeRequest({
        pageSize: props.numOfPosts,
        ip: ip.value
    }))
        .then(response => {
            location.value = response.locationFormattedAddress;
            opportunitiesNearMeResponse.value = response;
        });
}
</script>
<style>

</style>